import moment from 'moment';
import React, {useMemo } from 'react';
import ColorDots from '../../components/colorDot';
import ImgHolder from '../../components/imgHolder';
import { useGroupChatContext } from '../../context/groupchatContext';
import { isPatientChatMessage } from '../../helpers/utility';

const RecentChat = ({chat, onClickChatThread}) => {

    const groupChatContext = useGroupChatContext();
    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
    }));

    const formatLastMessageTime = () => {
        const messageTime = chat.last_message_at || chat.created;
        if (!messageTime) {
            return '';
        }
        const msgDate = moment(messageTime);
        if (!msgDate.isValid()) {
            return '';
        }
        if (msgDate.isSame(moment(), 'day')) {
            return msgDate.format('hh:mm A');
        }
        if (msgDate.isSame(moment().subtract(1, 'day'), 'day')) {
            return 'Yesterday';
        }
        return msgDate.format('MM/DD/YYYY');
    }

    const PatientTagInfo = () => {
        const patientInfo = isSelectedChatThread ? { ...chat.patient, ...selectedChat.patient } : chat.patient;
        const patientName = [patientInfo?.fname, patientInfo?.lname].filter(Boolean).join(' ') || patientInfo?.full_name || patientInfo?.name || '';
        const patientDob = patientInfo?.DOB ? moment(patientInfo.DOB) : null;
        const formattedDob = patientDob?.isValid() ? patientDob.format("MM/DD/YYYY") : '';
        const patientAge = patientInfo?.age !== undefined && patientInfo?.age !== null && patientInfo?.age !== '' ? `(${patientInfo.age} Y)` : '';
        const patientDemographics = [
            patientInfo?.sex,
            [formattedDob, patientAge].filter(Boolean).join(' ')
        ].filter(Boolean).join(', ');

        return (
            <>
                <div className="h-[42px] w-[42px] shrink-0 rounded-full">
                    <ImgHolder uuid={patientInfo?.file ? patientInfo?.file : patientInfo?.sex} />
                </div>
                <div>
                    <ColorDots dots={patientInfo?.patient_group_color} />
                </div>
                <div className="overflow-hidden text-left w-40">
                    <p className="text-md text-start font-medium text-gray-900 custom-text-ellipsis" title={patientName}>{patientName}</p>
                    {patientInfo?.mrn ? <p className="text-xs text-start font-medium text-gray-500" >MRN: {patientInfo.mrn}</p> : null}
                    {patientDemographics ? <p className="text-xs text-start font-medium text-gray-500 capitalize">{patientDemographics}</p> : null}
                    <p className="truncate text-sm font-normal text-slate-400" title={chat.location?.name}>{chat.location?.name}</p>
                </div>
            </>
        )
    }

    const LocationTagInfo = () => {
        return (
            <div className="overflow-hidden text-left w-48">
                <p className="text-md text-start font-medium text-gray-900 custom-text-ellipsis" title={chat.location?.name}>{chat.location?.name}</p>
                <p className="truncate text-sm font-normal text-slate-400" title={chat.location?.address1}>{chat.location?.address1}</p>
            </div>
        )
    }

    const isChatThreadSelected = () => {
        if(isPatientChatMessage(chat)){
            return chat.pid == selectedChat.pid && (chat.location_id || chat.location?.id) == (selectedChat.location_id || selectedChat.location?.id);
        } else {
            return (chat.location_id || chat.location?.id) == (selectedChat.location_id || selectedChat.location?.id);
        }
    }

    if(!chat){
        return null;
    }

    const isSelectedChatThread = isChatThreadSelected();

    const BadgeList = () => (
        isSelectedChatThread ? null :
        <div className="flex max-w-[4.75rem] flex-wrap justify-end gap-1">
            {chat.unread_message_count ? <p title="Unread Messages" className={`h-4 px-1.5 place-content-center rounded-full bg-green-500 text-xs text-slate-200 ${chat.unread_message_count > 99 ? 'min-w-[2rem]' : ''}`}>{chat.unread_message_count}</p> : null}
            {chat.unread_urgent_count ? <p title="Urgent Messages" className={`h-4 px-1.5 place-content-center rounded-full bg-red-500 text-xs text-slate-200 ${chat.unread_urgent_count > 99 ? 'min-w-[2rem]' : ''}`}>{chat.unread_urgent_count}</p> : null}
            {chat.unread_mention_count ? <p title="Mentions" className={`h-4 px-1.5 place-content-center rounded-full bg-[#93c5fd] text-xs text-slate-200 ${chat.unread_mention_count > 99 ? 'min-w-[2rem]' : ''}`}>{chat.unread_mention_count}</p> : null}
        </div>
    )

    return (
        <button className={`flex items-center gap-2 w-full px-2 py-2 transition-colors duration-300 hover:bg-light-gray-f1 border-b-[1px] ${isSelectedChatThread ? 'bg-light-gray-f1' : ''}`}  onClick={()=>onClickChatThread(chat)}>
            {isPatientChatMessage(chat) ? <PatientTagInfo /> : <LocationTagInfo /> }
            <div className="ml-auto flex min-w-[5rem] flex-col items-end gap-1 self-start text-right">
                {formatLastMessageTime() ? <p className="text-xs text-slate-400">{formatLastMessageTime()}</p> : null}
                <BadgeList />
            </div>
        </button>
    );
};

export default RecentChat;
